export * from './upload-document-photo.module';
export * from './upload-document-photo.component';
